export const formOrderObjFromCart = (data = null) => {
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    const entityDetails = data?.itemDetail?.entityDetails || null;
    return {
        appProfile: catalogConfig?.applicationService || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.appShortName || null,
        sector: catalogConfig?.sector || null,
        environment: catalogConfig?.environment || null,
        department: environmentDetails?.department || null,
        appRegion: environmentDetails?.applicationRegion || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        entityDetails: {
            businessCi: environmentDetails?.businessService || catalogConfig?.tags?.BusinessService || null,
        },
        ...(catalogConfig?.environmentDetails?.environment === 'Production' && {
            isHighAvailability: catalogConfig?.highAvailability === true ? 'yes' : 'no',
        }),
        awsAccountId: catalogConfig?.awsAccountId || null,
        vpcId: catalogConfig?.vpcId || null,
        subnetId: catalogConfig?.dbSubnetGroupName || null,
        instanceName: catalogConfig?.rdsInstanceId || null,
        engine: catalogConfig?.engine || null,
        engineVersion: catalogConfig?.databaseVersion || null,
        majorEngineVersion: catalogConfig?.engineVersion || null,
        dbInstanceType: catalogConfig?.dbInstanceType || null,
        isMultiAzEnabled: catalogConfig?.haDeployment ? 'yes' : 'no',
        storageType: catalogConfig?.storageType || null,
        expDBSize: catalogConfig?.allocatedStorage || null,
        databaseName: catalogConfig?.dbName || null,
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),
        dbCharacterSet: catalogConfig?.dbCharacterSet || null,
        serverCollation: catalogConfig?.collation || null,
        isCDBRequired: catalogConfig?.containerDbRequired === true ? 'yes' : 'no',
        isMultiTenantRequired: catalogConfig?.multiTenantRequired === true ? 'yes' : 'no',
        dbNames: catalogConfig?.multiTenantDbNames || [],
        ...(catalogConfig?.adGroups?.length && { adGroup: catalogConfig?.adGroups?.[0] }),
        ...(environmentDetails?.domain && { domain: environmentDetails?.domain }),
        ...(environmentDetails?.adOu && { adOu: environmentDetails?.adOu }),
        ...(catalogConfig?.sqlDatabaseAuthentication != null && {
            sqlDbAuthentication: catalogConfig?.sqlDatabaseAuthentication === true ? 'yes' : 'no',
        }),
        ...(catalogConfig?.sqlDatabaseAuthentication === true && {
            isSqlAccExist: catalogConfig?.sqlAccountName ? 'yes' : 'no',
            ...(catalogConfig?.sqlAccountName && { sqlServiceAccountName: catalogConfig?.sqlAccountName }),
            ...(catalogConfig?.sqlAccountName == null &&
                environmentDetails?.accountOwnerId && {
                    sqlAccOwnerDetails: { gpid: environmentDetails?.accountOwnerId },
                }),
        }),
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    const entityDetails = data?.entityDetails || null;
    return {
        appProfile: catalogConfig?.applicationService || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.appShortName || null,
        sector: catalogConfig?.sector || null,
        appRegion: environmentDetails?.applicationRegion || null,
        environment: catalogConfig?.environment || null,
        department: environmentDetails?.department || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        entityDetails: {
            businessCi: environmentDetails?.businessService || catalogConfig?.tags?.BusinessService || null,
        },
        ...(catalogConfig?.environmentDetails?.environment === 'Production' && {
            isHighAvailability: catalogConfig?.highAvailability === true ? 'yes' : 'no',
        }),
        awsAccountId: catalogConfig?.awsAccountId || null,
        vpcId: catalogConfig?.vpcId || null,
        // subnetId: catalogConfig?.dbSubnetGroupName || null,
        instanceName: catalogConfig?.rdsInstanceId || null,
        engine: catalogConfig?.engine || null,
        engineVersion: catalogConfig?.databaseVersion || null,
        majorEngineVersion: catalogConfig?.engineVersion || null,
        dbInstanceType: catalogConfig?.dbInstanceType || null,
        isMultiAzEnabled: catalogConfig?.haDeployment ? 'yes' : 'no',
        storageType: catalogConfig?.storageType || null,
        expDBSize: catalogConfig?.allocatedStorage || null,
        databaseName: catalogConfig?.dbName || null,
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),
        dbCharacterSet: catalogConfig?.dbCharacterSet || null,
        serverCollation: catalogConfig?.collation || null,
        isCDBRequired: catalogConfig?.containerDbRequired === true ? 'yes' : 'no',
        isMultiTenantRequired: catalogConfig?.multiTenantRequired === true ? 'yes' : 'no',
        dbNames: catalogConfig?.multiTenantDbNames || [],
        ...(environmentDetails?.domain && { domain: environmentDetails?.domain }),
        ...(catalogConfig?.adGroups?.length && { adGroup: catalogConfig?.adGroups?.[0] }),
        ...(environmentDetails?.adOu && { adousDetails: { fullpath: environmentDetails?.adOu } }),
        ...(catalogConfig?.sqlDatabaseAuthentication != null && {
            sqlDbAuthentication: catalogConfig?.sqlDatabaseAuthentication === true ? 'yes' : 'no',
        }),
        ...(catalogConfig?.sqlDatabaseAuthentication === true && {
            isSqlAccExist: catalogConfig?.sqlAccountName ? 'yes' : 'no',
            ...(catalogConfig?.sqlAccountName && { sqlServiceAccountName: catalogConfig?.sqlAccountName }),
            ...(catalogConfig?.sqlAccountName == null &&
                environmentDetails?.accountOwnerId && {
                    sqlAccOwnerDetails: { gpid: environmentDetails?.accountOwnerId },
                }),
        }),

        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};
export const resetOrder = {
    // Application Section
    applicationName: null,
    appShortName: null,
    appProfile: null,
    drPriority: null,
    entityDetails: null,
    sector: null,
    sectorDetails: null,
    department: null,
    appRegion: null,
    environment: null,
    landingZoneDetails: null,
    hCode: null,
    hCodeDetails: null,
    appOwner: null,
    appOwnerDetails: null,

    // Resource Section
    awsAccount: null,
    awsAccountId: null,
    vpcId: null,
    subnetId: null,

    // Application Component Security Group Section
    componentName: null,
    componentNameDetails: null,

    // Rds Instance Section
    dbInstanceType: null,
    databaseName: '',
    isManualDBName: false,
    engineVersion: null,
    engine: null,
    majorEngineVersion: null,
    selectedEngineOption: null,
    expDBSize: null,
    isMultiAzEnabled: 'no',
    instanceName: null,
    serverCollation: null,
    timeZone: null,
    storageType: null,
    storageTypeDetails: null,
    isCDBRequired: 'no',
    isMultiTenantRequired: 'no',
    dbNames: [],
    dbCharacterSet: null,

    // Access Management Section
    domain: null,
    adGroup: null,
    adous: null,
    adousDetails: null,
    sqlDbAuthentication: null,
    isSqlAccExist: null,
    sqlAccOwner: null,
    sqlAccOwnerDetails: null,
    sqlServiceAccountName: null,

    tags: [],
    estimatedCost: {
        details: [],
        qty: null,
        totalOneTimeCost: {
            frequency: 'one time',
            estCost: null,
            currency: 'USD',
        },
        totalRecurringCost: {
            frequency: 'monthly',
            estCost: null,
            currency: 'USD',
        },
        notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
    },
    placeNewOrder: new Date(),
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isUpdatedToCart: false,
    isCostSplitOpen: false,
    isDiskOpen: false,
    isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const costPayload = ({ order = [], catalogCode }) => {
    const payload = {
        catalogServiceCode: catalogCode,
        quantity: 1,
        catalogConfig: {
            instanceType: order?.dbInstanceType,
            databaseEdition: order?.selectedEngineOption?.label,
            storageSize: order?.expDBSize,
            storageType: order?.storageTypeDetail?.storageType,
            haDeployment: order?.isMultiAzEnabled === 'yes',
            ...(order?.isEDRSEnabled === 'yes' && { edrsEnabled: true }),
            environmentDetails: {
                region: order?.landingZoneDetails?.region,
                environment: order?.environment,
            },
        },
    };
    return payload;
};

export const getRdsLabel = (catalogCode) => {
    switch (catalogCode) {
        case 'AWSORACLERDSINSTANCE':
            return { label: 'Oracle', engineType: 'oracle-rds' };
        case 'AWSSQLRDSINSTANCE':
            return { label: 'SQL', engineType: 'sql-rds' };
        case 'AWSMYSQLRDSINSTANCE':
            return { label: 'MySQL', engineType: 'mysql-rds' };
        default:
            return { label: 'PostgreSQL', engineType: 'postgresql-rds' };
    }
};
